// extracted by mini-css-extract-plugin
export default {"name":"Author-styles__name__gQO4A","job_title":"Author-styles__job_title__EOj41","bio":"Author-styles__bio__Xfl4t"};